import React from 'react';
import CioPlpProvider from './CioPlpProvider';
import CioPlpGrid from '../CioPlpGrid';
// Wrapper component for CioPlpProvider with default Markup
export default function CioPlp(props) {
    const { children, initialSearchResponse, initialBrowseResponse, sortConfigs, paginationConfigs, filterConfigs, ...rest } = props;
    const defaultMarkup = (React.createElement(CioPlpGrid, { initialSearchResponse: initialSearchResponse, initialBrowseResponse: initialBrowseResponse, sortConfigs: sortConfigs, paginationConfigs: paginationConfigs, filterConfigs: filterConfigs }));
    return (React.createElement("div", { className: 'cio-plp' },
        React.createElement(CioPlpProvider, { ...rest }, children || defaultMarkup)));
}
